export const shapeTypes = {
  RECTANGLE: 'rectangle',
  CIRCLE: 'circle',
  LINE: 'line',
  POLYGON: 'polygon',
  ELLIPSE: 'ellipse',
  TRIANGLE: 'triangle',
  PATH: 'path',
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio'
};

export function getShapeOptions(videoCanvas) {

  const shapes = [{
    type: shapeTypes.RECTANGLE,
    name: 'Rectangle'
  }, {
    type: shapeTypes.CIRCLE,
    name: 'Circle'
  }, {
    type: shapeTypes.LINE,
    name: 'Line'
  }, {
    type: shapeTypes.POLYGON,
    name: 'Polygon'
  }, {
    type: shapeTypes.ELLIPSE,
    name: 'Ellipse'
  }, {
    type: shapeTypes.TRIANGLE,
    name: 'Triangle'
  }, {
    type: shapeTypes.PATH,
    name: 'Path'
  }, {
    type: shapeTypes.TEXT,
    name: 'Text'
  }, {
    type: shapeTypes.IMAGE,
    name: 'Image'
  }];

  if (videoCanvas === true) {
    shapes.push({
      type: shapeTypes.VIDEO,
      name: 'Video'
    });
    shapes.push({
      type: shapeTypes.AUDIO,
      name: 'Audio'
    });
  }

  return shapes;

}